
import React, { useContext } from 'react';
import { AppContext, Screen } from '../context/AppContext';
import { HomeIcon, RestaurantIcon, OrderIcon, AccountIcon } from './icons';
import { useOrder } from '../context/OrderContext';
import { motion } from 'framer-motion';

const BottomNav: React.FC = () => {
  const { view, setView } = useContext(AppContext);
  const { totalItems } = useOrder();

  const navItems: { screen: Screen; label: string; icon: React.ElementType }[] = [
    { screen: 'home', label: 'Accueil', icon: HomeIcon },
    { screen: 'restaurants', label: 'Restos', icon: RestaurantIcon },
    { screen: 'orders', label: 'Commandes', icon: OrderIcon },
    { screen: 'account', label: 'Compte', icon: AccountIcon },
  ];

  return (
    <nav className="fixed bottom-6 left-4 right-4 max-w-sm mx-auto bg-white shadow-[0_8px_30px_rgb(0,0,0,0.12)] rounded-full z-50 border border-gray-100">
      <div className="flex justify-around items-center h-16 px-2">
        {navItems.map((item) => {
          const isActive = view.screen === item.screen || (item.screen === 'restaurants' && view.screen === 'restaurantDetail');
          return (
            <button
              key={item.screen}
              onClick={() => setView({ screen: item.screen })}
              className={`flex flex-col items-center justify-center w-full h-full relative cursor-pointer outline-none select-none`}
            >
              {/* Background moving pill */}
              {isActive && (
                <motion.div
                  layoutId="active-pill"
                  className="absolute inset-0 m-auto w-16 h-16 bg-red-600 rounded-full shadow-lg shadow-red-600/50"
                  transition={{ type: "spring", stiffness: 400, damping: 30 }}
                  style={{ borderRadius: 9999 }} // Force circle
                />
              )}

              {/* Icon & Content - Z-index above the moving pill */}
              <div className="relative z-10 flex flex-col items-center justify-center">
                <item.icon
                  className={`w-6 h-6 transition-colors duration-200 ${isActive ? 'text-white' : 'text-gray-400'
                    }`}
                />

                {/* No badge for Commandes since it's history now */}
              </div>


            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
